import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { useDispatch, useSelector } from 'react-redux';
import { useField } from 'formik';

import utils from 'utils';
import actions from 'state/actions';
import selectors from 'state/selectors';

import Header from 'components/Modal/Header';
import Textarea from 'components/Input/Textarea';
import Modal from 'components/Modal';

export const TextAreaContainer = styled.div``;

export const IntervalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 15px;
  > div:not(:last-child) {
    margin-right: 20px;
  }
  input {
    width: 90px;
  }
`;

export const IntervalTitle = styled.div`
  font-weight: bold;
`;

const Selection = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();
  const modalProps = useSelector(selectors.modal.getModalProps);
  const [textAreaValue, setTextAreaValue] = useState<string>('');
  const [protocolsField, , helpersProtocol] = useField<string>('protocols');
  const [vatNumbersField, , helpersVatNumbers] = useField<string>('vatNumbers');
  const [ragSocialeField, , helpersRagSociale] = useField<string>('ragioneSociale');

  useEffect(() => {
    if (modalProps.type === 'protocol') {
      setTextAreaValue(protocolsField.value);
    } else if (modalProps.type === 'vat') {
      setTextAreaValue(vatNumbersField.value);
    } else if (modalProps.type === 'rag') {
      setTextAreaValue(ragSocialeField.value);
    }
  }, [modalProps.type, protocolsField.value, ragSocialeField.value, vatNumbersField.value]);

  const confirmValues = () => {
    if (modalProps.type === 'protocol') {
      helpersProtocol.setValue(textAreaValue);
    } else if (modalProps.type === 'vat') {
      helpersVatNumbers.setValue(textAreaValue);
    } else if (modalProps.type === 'rag') {
      helpersRagSociale.setValue(textAreaValue);
    }
  };

  return (
    <>
      <Header
        title={
          modalProps.type === 'protocol'
            ? t('select_protocols_title')
            : modalProps.type === 'vat'
            ? t('select_vat_title')
            : t('select_rag_soc_title')
        }
        subtitle={
          modalProps.type === 'protocol'
            ? t('select_protocols_subtitle')
            : modalProps.type === 'vat'
            ? t('select_vat_subtitle')
            : t('select_rag_soc_subtitle')
        }
      />
      <TextAreaContainer>
        <Textarea onChange={(e) => setTextAreaValue(e.target.value)} value={textAreaValue} />
      </TextAreaContainer>
      <Modal.Footer
        confirmAction={() => {
          confirmValues();
          dispatch(actions.modal.closeModal());
        }}
        confirmText={t('confirm')}
        confirmDisabled={
          !textAreaValue ||
          !/^[^\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+(?:,\s*[^\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+)*$/.test(
            textAreaValue,
          )
        }
        closeButtonText={t('cancel')}
        dontCloseOnConfirm
      />
    </>
  );
};

export default Selection;
